import { settingsContract } from './settings.contract';
import { notificationsContract, notificationsStreamRoute } from './notifications.contract';
import { customizedTriggersContract } from './customizedTriggers.contract';

// Individual re-exports (for route files importing specific contracts)
export { settingsContract } from './settings.contract';
export { notificationsContract, notificationsStreamRoute } from './notifications.contract';
export { customizedTriggersContract } from './customizedTriggers.contract';

// Aggregated export for service client creation
export const notificationEngineContracts = {
	settingsContract,
	notificationsContract,
	customizedTriggersContract,
};
